import { InputLabel } from "@mui/material";
import moment from "moment";
import { Grid } from "@mui/material";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useParams } from "react-router-dom";

import { getLayouts } from "../../../store/ducks/duckLayout";
import NavBar from "../../../components/Navbar";
import "../../../utils/chart";
import { getFilterLog, getTabLog } from "../../../store/ducks/duckLogger";

const AnalyticsFiltered = () => {
  const dispatch = useDispatch();
  const dataAnalytics = useSelector((state) => state?.analytics.data).sort((a, b) =>
    a.count < b.count ? 1 : -1,
  );
  const [resource, setResource] = useState("Tabs");
  const user = "personal";
  const { id } = useParams();
  const [firstRender, setFirstRender] = useState(true);

  const [until, setUntil] = useState(moment().format("yyyy-MM-DD"));
  const [since, setSince] = useState(moment(moment().subtract(1, "M")).format("yyyy-MM-DD"));
  // Guarda la data traida del duck de layout y lo guarda en un array ordenado por el campo name
  const dataLayoutsArray = useSelector((state) => {
    let data = state.layout.dataLayout.sort((a, b) => (a.name > b.name ? 1 : -1));
    let dataL = [];

    data.forEach((x, index) => {
      dataL[index] = x;
    });

    return dataL;
  });

  useEffect(() => {
    if (firstRender) {
      dispatch(getLayouts());
      setFirstRender(false);
    }
  }, [dispatch, firstRender, id]);

  //Primero verifica si le pasamos un id por useParams, despues si es un numero, si no lo
  // es, usa el metodo que nos retorna el id buscando por el pathname
  const layoutId = id ? (!isNaN(id) ? parseInt(id) : getIdCustomRoute(id)) : 0;

  //Retorna un id cuando el pathname del que clickean las analytics es custom como PRE o Annual
  function getIdCustomRoute(Pathname) {
    let dataL = dataLayoutsArray?.find((x) => x.name.includes(Pathname))?.id;

    return dataL;
  }

  let tabFilterDTO = {
    id: 0,
    since: since,
    until: until,
    user: user,
    resourceId: layoutId,
  };

  useEffect(() => {
    if (layoutId) {
      switch (resource) {
        case "Tabs":
          dispatch(getTabLog(tabFilterDTO));
          break;
        case "Filters":
          dispatch(getFilterLog(tabFilterDTO));
          break;
        default:
          break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, since, until, resource, layoutId, user, id]);

  const data = {
    labels: dataAnalytics.map((x) => x.name).reverse(),
    datasets: [
      {
        label: "Visited",
        data: dataAnalytics.map((x) => x.count).sort((a, b) => (a.count < b.count ? 1 : -1)),
        fill: false,
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "rgba(255, 99, 132, 0.2)",
      },
    ],
  };

  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: false,
          },
        },
      ],
    },
  };

  return (
    <>
      <>
        <NavBar />
        <div className="header">
          <h1 className="title">. .</h1>
        </div>
        <Grid
          container
          alignItems="center"
          direction="row"
          justify="center"
          style={{ marginBottom: 20 }}
          xs={12}
        >
          <Grid xs={1} />
          <Grid xs={1.5}>
            <InputLabel id="labelResource">Resource</InputLabel>
            <Select
              fullWidth
              defaultValue="Tabs"
              id="selectResource"
              labelId="labelResource"
              variant="outlined"
              onChange={(e) => setResource(e.target.value)}
            >
              <MenuItem value="Tabs">Tabs</MenuItem>
              <MenuItem value="Filters">Filters</MenuItem>
            </Select>
          </Grid>
          <Grid xs={1} />
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Grid xs={2}>
              <InputLabel id="labelSince">Since</InputLabel>
              <DatePicker
                format="MM/DD/YYYY"
                label=""
                slotProps={{ textField: { variant: "outlined" } }}
                value={moment(since)}
                onChange={(date) => setSince(moment(date).format("yyyy-MM-DD"))}
              />
            </Grid>
            <Grid xs={1} />
            <Grid xs={2}>
              <InputLabel id="labelUntil">Until</InputLabel>
              <DatePicker
                format="MM/DD/YYYY"
                label=""
                maxDate={moment()}
                slotProps={{ textField: { variant: "outlined" } }}
                value={moment(until)}
                onChange={(date) => setUntil(moment(date).format("yyyy-MM-DD"))}
              />
            </Grid>
          </LocalizationProvider>
        </Grid>

        <Line data={data} options={options} />
      </>
      ;
    </>
  );
};

export default AnalyticsFiltered;
